import React, { useState } from "react";
import Button from "./Button";
import move from "../../src/assets/move.svg";
import ProceedToTrade from "../pages/dashboard/ProceedToTrade";
import { useNavigate } from "react-router-dom";

function BuyCheckout({ mode, range, assets }) {
  const navigate = useNavigate();
  // const [trade, setTrade] = useState(false);
  return (
    <div className="md:py-[115px] py-[50px] md:px-[65px] px-[30px] bg-white md:w-[672px] md:h-[797px] rounded-lg   ">
      <div className="md:mb-[82px] mb-[30px] ">
        <Button
          bg={"bg-[#FBC108db]"}
          height={"md:h-[56px] h-[30px]"}
          width={"md:w-[168px] w-[127px] "}
          radius={"rounded-sm md:rounded-lg "}
          color={"text-white text-sm md:text-base"}
        >
          {mode}
        </Button>
      </div>

      <div className="flex items-center justify-between mb-[20px] md:mb-[59px] w-full">
        <div>
          <h1 className="text-[#0000005e] text-xs md:text-base">Rates:</h1>
          <p className="text-[#060606] font-bold md:text-2xl">250/USD</p>
        </div>
        <div>
          <h1 className="text-[#0000005e] text-xs md:text-base">Range:</h1>
          <p className="text-[#060606] font-bold md:text-2xl">{range}</p>
        </div>
        <div>
          <h1 className="text-[#0000005e] text-xs md:text-base">Assets</h1>
          <p className="text-[#060606] font-bold md:text-2xl  ">{assets}</p>
        </div>
      </div>
      <div className="md:w-[333px] w-[250px] md:mb-[61px] mb-[20px] ">
        <div className="flex items-center md:mb-[31px] mb-[10px] gap-2 text-sm md:text-base">
          <h6>How much do you want to {mode.toLowerCase()}?</h6>
          <img src={move} alt="" />
        </div>
        <input
          type="number"
          className="w-full md:h-[51px] h-[30px] bg-[#EFE9E9] rounded-lg pl-[12px] mb-[18px] md:placeholder:text-base placeholder:text-xs text-sm md:text-base"
          placeholder="Enter amount (N) "
        />
        <div className=" h-[2px] bg-[#FBC108] mb-[30px] "></div>
        <div className="flex text-sm md:text-base items-center justify-between">
          <h6>You will {mode === "Buy" ? "send" : "receive"};</h6>
          <h6 className="md:text-2xl">20,000 tyrion</h6>
        </div>
      </div>
      <button
        className="bg-[#FBC108db]
        md:h-[60px] h-[30px]
      md:w-[254px] w-[127px] 
        md:rounded-lg rounded-sm text-xs
        text-white"
        // onClick={() => setTrade(true)}
        onClick={() => navigate("/proceed-to-trade")}
      >
        Proceed to trade
      </button>

      {/* {trade && (
        <div className=" ">
          <div
            className="absolute top-0 left-0 z-20 w-full h-full bg-black bg-opacity-70 "
            // onClick={handleCheckout}
          ></div>
          <div className="absolute top-[30px] left-[-134px] z-30">
            <ProceedToTrade />
          </div>
        </div>
      )} */}
    </div>
  );
}

export default BuyCheckout;
